import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { configuration } from 'src/configuration';
import { ApiServiceService } from '../service/api-service.service';
import { SharedService } from '../service/shared.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent {
isSubmitted = false;
changePasswordForm: FormGroup;
myFormSubmit = false;

constructor(
  private formBuilder: FormBuilder,
  private apiService: ApiServiceService,
  public shared: SharedService
) {
  this.changePasswordForm = this.formBuilder.group({
    old_password: ['', Validators.required],
    new_password: ['', Validators.required],
    confirm_password: ['', Validators.required],
  });
  this.shared.isWhiteMenu = true;

}

get formControls() {
  return this.changePasswordForm.controls;
}

async onSubmit(){
      this.myFormSubmit=true;
      console.log(this.changePasswordForm.value)
      let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.CHANGE_PASSWORD,
        this.changePasswordForm.value
      );
      console.log("res", res);
      if (res && !res.error) {
        this.isSubmitted = true;
      }
    }
}

